import React from "react";
import ReactDOM from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const Modal = ({
  title,
  text,
  onClose,
  success = true,
  actions = [],
  ok,
}) => {
  const resolvedActions = (() => {
    if (actions.length > 0) {
      return actions.map((action) => ({
        label: action.label,
        onClick: action.onClick ?? action.onClose ?? onClose,
        success: action.success,
      }));
    }
    if (ok) {
      return [{ label: ok, onClick: onClose, success: !success }];
    }
    if (onClose) {
      return [{ label: "OK", onClick: onClose, success: !success }];
    }
    return [];
  })();

  const modalContent = (
    <div className="fixed h-screen top-0 left-0 w-full bg-black/70 flex justify-center items-start z-[9999]">
      <div
        className={`p-6 mt-[200px] rounded-xl w-[90%] max-w-md text-center relative shadow-2xl animate-[showtitle_0.3s_ease-out_forwards]
          ${success ? "bg-[#006674] text-white" : "bg-red-700 text-white"}`}
      >
        <div className="flex justify-center items-center mb-4">
          <FontAwesomeIcon
            icon={success ? faCheckCircle : faTriangleExclamation}
            className="text-4xl text-white"
          />
        </div>
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <p className="whitespace-pre-line mb-6">{text}</p>

        <div className="flex justify-center gap-3 flex-wrap">
          {resolvedActions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={`px-4 py-2 rounded-lg ${
                action.success
                  ? "bg-red-600 text-white hover:bg-red-700"
                  : "bg-white text-[#006674]"
              }`}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.getElementById("modal-root"));
};
export default Modal;
